import type {ComponentPropsWithRef} from 'react';
import React from 'react';

import {Row} from './row';
import {getRowData} from './utils';

export type FootProps = ComponentPropsWithRef<'tfoot'> & {
    /**
     * Custom foot height passed down to cells
     */
    height?: number,
};

/**
 * Table footer section. Prefer wrapping cells in an explicit `<Row>`:
 *
 * ```tsx
 * <Foot>
 *   <Row>
 *     <Cell>Total</Cell>
 *     <Cell>$1M</Cell>
 *   </Row>
 * </Foot>
 * ```
 *
 * Passing bare `<Cell>` children directly (without a `<Row>`) is deprecated
 * and will be removed in 6 months 03-03-2026.
 */
export const Foot = ({children, height, ref, ...rest}: FootProps) => {
    const {children: mappedChildren, wrappedCells} = getRowData({children, height}, Row);

    return (
        <tfoot {...rest} ref={ref}>
            {mappedChildren}
            {wrappedCells}
        </tfoot>
    );
};
